export default {
  ACCOUNT_STATEMENT: "Rekening overzicht",
  ACCOUNT_STATEMENTS: "Rekeningoverzichten",
  ACCOUNT_STATEMENTS_BALANCE: "Eindsaldo Rekeningoverzicht",
  ACCOUNT_STATEMENTS_DATE: "Aanmaakdatum",
  ACCOUNT_STATEMENTS_MESSAGE: "Rekeningoverzichten",
  ACCOUNT_STATEMENTS_NR: "Rekeningoverzichtnummer",
  ACCOUNT_STATEMENTS_PAYMENT: "Betaaldatum rekeningoverzicht",
  ACCOUNT_STATEMENTS_SEARCH: "Zoek op betaaldatum",
  ACCOUNT_STATEMENTS_SERIAL: "Volgnummer rekeningoverzicht",
  ACTION: "Actie",
  ADD_COMMENT: "Opmerking toevoegen",
  ADD_ROW: "rij toevoegen",
  ADMINISTRATION: "Administratie",
  ADVANCED_SEARCH: "Uitgebreid zoeken",
  ALL: "Alle",
  ALREADY_DELIVERED: "Reeds geleverd",
  AMOUNT: "Bedrag",
  AREA_STATEMENT: "Areaalopgaven",
  AREA_STATEMENT_CREATE: "Areaalopgaven invoeren",
  AREA_STATEMENT_INFO: "Areaalopgaven bekijken",
  AREA_STATEMENT_MAKE: "Areaalopgave maken",
  AREA_STATEMENT_NO_SELECT_ERROR: "Ten minste één gebiedsoverzicht selecteren",
  AREA_STATEMENT_MORE_THAN_ONE_ERROR:
    "U kunt slechts één areaalopgave per keer aanmaken. Maak een nieuwe selectie.",
  AREA_STATEMENT_SEARCH:
    "Zoek op wederpartij, oogstjaar en geslacht of cultivar",
  AREA_STATEMENT_TITLE: "Mijn areaalopgaven",
  AREA_STATEMENT_AVAILABLE: "Geen Opgave",
  ARTICLE: "Artikel",
  ARTICLE_DESCRIPTION: "Artikel omschrijving",
  AUCTION: "Veiling",
  BALANCE: "Beginsaldo",
  BALANCE_MUTATION: "Saldo mutaties",
  BALANCE_PREV: "Vorig saldo",
  BIO: "Bio",
  FYTOSANITAR: "Fytosanitair",
  BOTH: "Beide",
  BROKEN_STORAGE_ALERT:
    "De kolomconfiguraties zijn bijgewerkt naar de standaard instellingen voor deze pagina. U dient de kolommen opnieuw aan te passen mocht u deze gewijzigd hebben. Dit gaat via de knop 'Kies kolommen'",
  BUYER_COMPANY: "Bedrijfsnaam koper KV",
  BUYER_COMPANY_NO_KV: "Bedrijfsnaam koper",
  BUYER_NAME: "Naam koper",
  BUYER_NR: "Nummer koper",
  BUYER_NR_REL: "Relatienummer koper KV",
  BUYER_REPS: "Vertegenwoordiger koper",
  CANCEL: "Annuleren",
  CANCELED: "Vervallen",
  CANNOT_UNDO: "U kunt dit niet ongedaan maken!",
  CHANGE_PASSWORD: "Wachtwoord wijzigen",
  CHOOSE: "Kiezen",
  CHOOSE_COLUMN: "Kies kolommen",
  CLEAR: "Wissen",
  CLIENT_NAME: "Klantnaam",
  CLIENT_NR: "Klantnummer",
  CLOSED: "Afgesloten",
  CLOSING_BALANCE: "Eindsaldo",
  CNB_DESCRIPTION:
    "Bemiddeling in bloembollen, knollen en vaste planten sinds 1919",
  COMPANY_DETAILS: "Bedrijfsgegevens",
  COMPANY_INFORMATION: "Bedrijfsinformatie",
  COMPANY_INFORMATION_EDIT: "Wijzigen",
  COMPANY_FINANCIAL: "Financiële gegevens",
  COMPANY_NAME: "Bedrijfsnaam",
  COMPANY_LEGAL_PERSON: "Ondernemingsvorm",
  COMPANY_KVK_NUMBER: "KVK nummer",
  COMPANY_OTHER_DETAILS: "Overige gegevens",
  COMPANY_PHONE: "Telefoonnummer",
  COMPANY_EMAIL: "E-mailadres",
  COMPANY_EMAIL_TOOLTIP:
    "Dit e-mail adres wordt getoond op uw overeenkomsten. Dit e-mail adres hangt niet samen met de nieuwsbrief van CNB.",
  COMPANY_PHONE_TOOLTIP:
    "Dit telefoonnummer wordt getoond op al uw documenten, zoals overeenkomsten en facturen. Als u overige telefoonnummers wilt wijzigen dient u contact op te nemen met de afdeling administratie via administratie@cnb.nl.",
  COMPANY_DIGITAL_TOOLTIP:
    "Als u digitaal zaken doet met CNB ontvangt u uw documenten via Mijn CNB, overeenkomsten worden ook via de mail verstuurd. Wij adviseren onze klanten digitaal zaken te doen, omdat dit tijdbesparend is en efficiënt werkt, waarbij alles op één plek is gearchiveerd.",
  COMPANY_CNB_MEMBERSHIP_TOOLTIP:
    "Als u lid wilt worden van CNB neem dan contact op met onze afdeling administratie",
  COMPANY_CORRESPONDENCE_ADDRESS: "Correspondentieadres",
  COMPANY_CORRESPONDENCE_POSTCODE: "Correspondentiepostcode",
  COMPANY_CORRESPONDENCE_PLACE: "Correspondentieplaats",
  COMPANY_CORRESPONDENCE_COUNTRY: "Correspondentieland",
  COMPANY_BUSINESS_ADDRESS: "Vestigingsadres",
  COMPANY_BRANCH_POSTCODE: "Vestigingspostcode",
  COMPANY_LOCATION: "Vestigingsplaats",
  COMPANY_COUNTRY: "Vestigingsland",
  COMPANY_DELIVERY_ADDRESS: "Voorkeurafleveradres",
  COMPANY_DELIVERY_POSTCODE: "Afleverpostcode",
  COMPANY_DELIVERY_PLACE: "Afleverplaats",
  COMPANY_DELIVERY_COUNTRY: "Afleverland",
  COMPANY_IBAN: "IBAN",
  COMPANY_SWIFT: "SWIFT-code",
  COMPANY_BTW: "BTW status",
  COMPANY_EXPORTER: "Exporteur",
  COMPANY_BTW_NUMBER: "BTW-nummer",
  COMPANY_BKD_NUMBER: "BKD nummer",
  COMPANY_NAKT_NUMBER: "NAKT nummer",
  COMPANY_PHYTO_NUMBER: "Fytosanitair nummer",
  COMPANY_CNB_LID: "CNB lid",
  COMPANY_CNB_MEMBER_FORM: "CNB lid vanaf",
  COMPANY_EDI_CODE: "EDI code/GLN code",
  COMPANY_SUSTAINABILITY_CERTIFICATE: "Duurzaamheidscertificaat",
  COMPANY_DIGITAL: "Digitaal zaken doen",
  COMPANY_UPDATE_MESSAGE: "Uw wijzigingen zijn geregistreerd",
  COMPANY_UPDATE_ERROR_MESSAGE:
    "Oeps. Er is iets fout gegaan. Probeer het later nog eens. Als het niet lukt kunt u contact met ons opnemen op info@cnb.nl",
  COMPANY_CERTIFICATE_PARTICIPATION: "Deelname",
  COMPANY_CERTIFICATE_REGISTRATION: "Registratienummer",
  COMPANY_CERTIFICATE_ORGANISATION: "Certificeringsorganisatie",
  COMMENT: "Opmerking",
  CONFIRM_CONTINUE: "Wilt u verder gaan?",
  CONTACT: "Contact",
  CONTACT_CNB: "CNB Contact",
  CONTACT_FILES: "Bijlage",
  CONTACT_SUBJECT: "Onderwerp",
  CONTACT_TEXT: "Toelichting",
  CONTACT_USER: "Gebruikersnaam",
  COST: "Kosten",
  COUNTERPARTY: "Wederpartij",
  COUNTERPARTY_COMPANY: "Bedrijfsnaam wederpartij",
  COUNTERPARTY_NAME: "Naam wederpartij",
  COUNTERPARTY_NAME_REL: "Relatienaam",
  COUNTERPARTY_NR: "Nr. wederpartij",
  COUNTERPARTY_NR_REL: "Relatienummer wederpartij",
  COUNTERPARTY_NUMBER: "Nummer wederpartij",
  COUNTERPARTY_VAT: "BTW-status wederpartij",
  CULTIVAR: "Cultivar",
  CULTIVATION_ADVICES: "Teeltadvies",
  CULTIVATION_ADVICES_ADD: "Teeltadvies toevoegen",
  CULTIVATION_ADVICES_EDIT: "Pagina bewerken",
  CULTIVATION_ADVICES_HEADER: "Mijn teeltadvies",
  CULTIVATION_ADVICES_PDF: "Pdf",
  CULTIVATION_ADVICES_IMG: "Foto",
  CULTIVATION_ADVICES_MSG: "Berichten teeltadvies",
  CULTIVATION_ADVICES_SEARCH: "Zoek op Titel",
  CULTIVATION_LOCATIONS: "Teeltlocaties-Groeiplaatsen: Adres- (Woon)plaats",
  CURRENT_DATE: "Huidige datum",
  CUSTOMER_CHANGE: "Ander bedrijf selecteren",
  CUSTOMER_NAME: "Klantnaam",
  CUSTOMER_SEARCH: "Zoeken op klantnaam en nummer",
  DASHBOARD: "Dashboard",
  DATE: "Datum",
  DATE_LABEL: "t/m",
  DAYS: "dagen",
  DEDUCTIONS_BLOCKAGES: "Inhoudingen en  blokkeringen",
  DELIVERIED_BY: "Geleverd door",
  DELIVERIED_QUANTITY: "Aantal geleverd",
  DELIVERIED_TO: "Geleverd aan",
  DELIVERIES: "Leveringen bekijken",
  DELIVERIES_ADD_LINE: "Regel toevoegen",
  DELIVERIES_ADDRESS: "Afw. adres",
  DELIVERIES_ADDRESS_HEADER: "Levering adres",
  DELIVERIES_AM: "AM-Status",
  DELIVERIES_AM_TYPE: "AM-Status partij",
  DELIVERIES_BATCH: "Partij",
  DELIVERIES_BIO: "Biologisch geteeld",
  DELIVERIES_BKD: "BKD Certificaat",
  DELIVERIES_BUYER: "Voor koper",
  DELIVERIES_BUYER_NR: "Klantnummer koper",
  DELIVERIES_CARRIER: "Vervoerder",
  DELIVERIES_CERTIFICATE: "Certificaat type",
  DELIVERIES_CHECK: "Controleren",
  DELIVERIES_CITY: "Plaats van verzending",
  DELIVERIES_CLASS: "Klasse",
  DELIVERIES_COMMENT: "Opmerking voor leveringsnota",
  DELIVERIES_COMMENT_SUPPLIER: "Opmerking leverancier",
  DELIVERIES_COMMENT_TRANSPORT: "Opmerking transport",
  DELIVERIES_COMMENTS: "Opmerkingen",
  DELIVERIES_COMPLETE: "Afgerond",
  DELIVERIES_COPY_LINE: "Kopieer deze regel als nieuw",
  DELIVERIES_CREATE: "Leveringsnota maken",
  DELIVERIES_CULTIVAR: "Cultivar",
  DELIVERIES_DATE: "Leveringsdatum",
  DELIVERIES_DETAILS: "Leveringendetails",
  DELIVERIES_DOWNLOAD: "Leveringen downloaden",
  DELIVERIES_END_DATE: "Leverdatum",
  DELIVERIES_EXTRA_COST: "Extra kosten",
  DELIVERIES_FOR: "Kosten voor",
  DELIVERIES_FRANCO: "Franco",
  DELIVERIES_FUST: "#Fust",
  DELIVERIES_FUST_BUYER: "Fust koper",
  DELIVERIES_FUST_HEADER: "Fust",
  DELIVERIES_FUST_LINES: "Fustregels",
  DELIVERIES_FUST_SELLER: "Fust verkoper",
  DELIVERIES_FUST_THIRD_PARTY: "Fust derden",
  DELIVERIES_GENUS: "Geslacht",
  DELIVERIES_HEADER: "Leveringen",
  DELIVERIES_LINES: "Leveringsnotaregels",
  DELIVERIES_MINIMUM_ONE_ORDER:
    "Selecteer 1 regel voor het invoeren van een leveringsnota",
  DELIVERIES_NA: "NVT",
  DELIVERIES_NOT_FRANCO: "Niet-franco",
  DELIVERIES_NOTE:
    "Deze opmerking wordt niet door CNB gelezen, deze wordt op de leveringsnota afgedrukt",
  DELIVERIES_NR: "Notanummer",
  DELIVERIES_ONLY_ONE_BUYER:
    "U kunt een levering slechts voor één koper maken. Maak een nieuwe selectie.",
  DELIVERIES_PART: "Deel levering",
  DELIVERIES_PER_FUST: "#Per Fust",
  DELIVERIES_PLANNED_DATE: "Geplande Leverdatum",
  DELIVERIES_POSTAGE: "Frankering",
  DELIVERIES_PRICE_ONE: "Prijs/stuk",
  DELIVERIES_PRICE_PER_ONE: "Prijs per stuk",
  DELIVERIES_QUANTITY: "Aantal op order",
  DELIVERIES_REMOVE_LINE: "Verwijder deze regel",
  DELIVERIES_REPORT: "Levering voor afleveren melden aan ketenregister",
  DELIVERIES_REQUIREMENTS: "Frankeringsvoorschrift",
  DELIVERIES_REST: "Rest levering",
  DELIVERIES_REST_FUST: "#Rest Fust",
  DELIVERIES_SEARCH:
    "Zoek op notanummer, ordernummer, naam wederpartij en artikel omschrijving",
  DELIVERIES_SEND_AND_PRINT: "Verzenden en leveringsnota afdrukken",
  DELIVERIES_SOLD: "Aantal verkocht",
  DELIVERIES_STATUS_AM: "AM-vrij",
  DELIVERIES_STATUS_NOT_AM: "Niet-AM-vrij",
  DELIVERIES_STEPS: "Stap {currentStep}/6 Levering",
  DELIVERIES_TILL_DATE: "Leverdatum t/m",
  DELIVERIES_TOTAL: "#Totaal",
  DELIVERIES_TRANSFER: "Overnemen",
  DELIVERIES_TRANSPORT: "Transport",
  DELIVERIES_TRANSPORTER: "Transporteur",
  DELIVERIES_TYPE: "Soort levering",
  DELIVERIES_WHOLE: "Gehele levering",
  DELIVERY: "Levering",
  DESCRIPTION: "Omschrijving",
  DIFFERENT_HARVEST:
    "De geselecteerde orderregels hebben een afwijkend oogstjaar",
  DIRECT: "Rechtstreeks",
  DOCUMENT_DATE: "Document datum",
  DOCUMENT_TYPE_CONTRACT: "Contract teelt",
  DOCUMENT_TYPE_LEASE: "Huur",
  DOCUMENT_TYPE_MEDIATION: "Bemiddeling",
  DOCUMENT_TYPE_PORTION: "Portie",
  DOCUMENT_TYPE_RENT: "Pacht",
  DOWNLOAD_LOADING: "Download wordt voorbereid...",
  EDIT_COMMENT: "opmerking bewerken",
  EMAIL_AUTHOR: "Administratie CNB",
  EMAIL_ERROR: "Beheerder is niet bereikbaar, probeer het later opnieuw.",
  EMAIL_GREETINGS: "Beste relatie",
  EMAIL_PHONE: "Telefoon",
  EMAIL_REGARDS: "Met vriendelijk groeten",
  EMAIL_TEXT:
    "Bedankt voor het invullen van het formulier op Mijn CNB. \nWij zullen binnen 24 uur een reactie geven op uw vraag.",
  EMAIL_TITLE: "Mijn CNB: Contactformulier",
  ENTER_DELIVERIES: "Leveringen invoeren",
  EXCEL_INFO:
    "Met deze button maakt u een export naar Excel. U krijgt hierin alleen de waarde te zien van de geselecteerde zoekvelden. Niet die van de aangevinkte regels.",
  EXTERNAL_DOCUMENT: "Extern documentnummer",
  EXTERNAL_NR: "Extern referentie nummer",
  FAQ: "Veelgestelde vragen",
  FIXED: "Vast",
  FROM: "van",
  GREENHOUSE: "Kas",
  GREENHOUSE_OR_LAB: "Kas / Naam laboratorium",
  GROWER: "Kwekersvereniging",
  GROWER_COMPANY: "Bedrijfsnaam kwekersvereniging",
  GROWER_NAME: "Naam kwekersvereniging",
  GROWER_NR: "Nr. Kwekersvereniging",
  HARVEST_YEAR: "Oogstjaar",
  IMPORTANT: "Urgentie",
  INPUT_FILE_CHOOSE: "Kies bestand",
  INPUT_FILE_NO: "Geen bestand gekozen",
  INPUT_FILE_SELECTED: "Bestand gekozen",
  INSPECTION_DATE: "Inslagdatum",
  INSPECTION_NR: "Keurrapportnummer",
  INSPECTION_REPORT: "Keurrapporten K&P",
  INSPECTION_SEARCH: "Zoek op ontvangst nummer en naam leverancier",
  INSPECTION_TYPE: "Type bevestiging",
  INTERNAL_CULTIVATION_ADVICE: "Invoer bericht teeltadvies",
  INTERNAL_MANAGE: "Beheer intern",
  INTERNAL_NOTIFICATIONS: "Invoer meldingen",
  INVOICE: "Factuur",
  INVOICES: "Facturen",
  INVOICES_AMOUNT: "Factuurbedrag",
  INVOICES_AMOUNT_VAT: "Factuurbedrag (incl. BTW)",
  INVOICES_BALANCE: "Factuur saldo",
  INVOICES_BTW: "BTW%",
  INVOICES_BTW_AMOUNT: "BTW bedrag provisie",
  INVOICES_BTW_GROSS: "BTW bedrag",
  INVOICES_BTW_RATE: "BTW tarief provisie",
  INVOICES_COMMENT: "Opmerking extern",
  INVOICES_COMMISSION: "Provisie",
  INVOICES_COMMISSION_AMOUNT: "Provisie bedrag",
  INVOICES_COMMISSION_PERCENT: "Provisie percentage",
  INVOICES_COMMISSION_SALE:
    "Provisie bedrag {range} ({percentOne}% of {percentTwo}%)",
  INVOICES_DATE: "Factuurdatum",
  INVOICES_DESCRIPTION: "Factuur Omschrijving",
  INVOICES_DELIVERY: "Leverings/Ontvangst/Retour nota",
  INVOICES_DETAILS: "Factuurdetails",
  INVOICES_DOWNLOAD: "Download factuur",
  INVOICES_EX_BTW: "Bedrag ex. BTW",
  INVOICES_GROSS: "Bedrag factuurregel",
  INVOICES_INCL_BTW: "Bedrag factuurregel incl. BTW",
  INVOICES_INCL_BTW_RANGE:
    "Bedrag factuurregel incl. BTW {range} ({percentOne}% of {percentTwo}%)",
  INVOICES_KIND: "Factuursoort",
  INVOICES_LINES: "Factuurregels",
  INVOICES_MANUAL: "Handmatige factuur",
  INVOICES_NUMBER: "Factuurnummer",
  INVOICES_NR: "Factuur nr.",
  INVOICES_PAID: "Betaald bedrag factuur",
  INVOICES_RECENT: "Recente facturen",
  INVOICES_REST: "Restbedrag factuur",
  INVOICES_SEARCH: "Zoek op factuurnummer, wederpartij en artikel omschrijving",
  INVOICES_TOTAL: "Totaalbedrag factuur",
  INVOICES_TOTAL_INCL_VAT: "Totaalbedrag factuur incl.BTW",
  INVOICES_TOTAL_INCL_VAT_RANGE:
    "Totaalbedrag factuur incl. BTW {range} ({percentOne}% of {percentTwo}%)",
  INVOICES_TYPE: "Factuurtype",
  INVOICES_VIEW_ALL: "alle facturen bekijken",
  IVB: "IVB",
  KPB: "K&P",
  LAB_NAME: "Naam laboratorium",
  LICENSOR_NUMBER: "Licentiegever nummer",
  LINE_NR: "Regelnr",
  LINE_NUMBER: "Regelnummer",
  LIVERBAR_NOTE_ZANT:
    "Oppervlakte uitgangsmateriaal ten behoeve van leverbare knollen teelt\n",
  LOADING: "Loading...",
  LOG_OUT: "Uitloggen",
  KIND: "Soort",
  MAKE_CHOICE: "Maak een keuze",
  MARK_AS_READ: "Markeer als gelezen",
  MARK_AS_UNREAD: "Markeer als ongelezen",
  MARK_FULLY_DELIVERED: "Er volgt geen (aanvullende) levering",
  MAXIMUM_ONE_BUYER:
    "U kunt niet regels van biologische geteelde producten en niet-biologisch geteelde producten op één nota samenvoegen. “Maak een nieuwe selectie.",
  MESSAGE_RECEIPT_AND_RETURN: "ReceiptAndReturn",
  MESSAGE_RECEPTION: "Ontvangst",
  MESSAGE_REPORT: "Inspectie rapport",
  MESSAGE_SENT: "Uw bericht is verzonden. We zullen contact met u opnemen",
  MINIMUM_ONE_ORDER: "Selecteer minimaal 1 orderregel",
  MINUS_SIGN: "-",
  MULTIPLE_ADDRESSES:
    "De geselecteerde orderregels hebben meerdere afleveradressen. Indien u er voor kiest verder te gaan, zal het eerste afleveradres worden gehanteerd voor de totale levering",
  MY_DELIVERIES: "Mijn leveringen",
  MY_DELIVERIES_SEARCH:
    "Zoek op naam koper, ordernummer, geplande leverdatum en artikel omschrijving",
  MY_REPORTS: "Mijn rapportages",
  NAME: "Naam",
  NEW: "Nieuwe",
  NEWSLETTER: "Berichten teeltadvies",
  NEXT_STEP: "Volgende stap",
  NO: "Nee",
  NO_AVAILABLE: "Document niet beschikbaar",
  NO_DATA: "Er is geen data",
  NO_DATA_EXPORT: "Er zijn geen regels om te exporteren",
  NO_DOCUMENT: "Document bestaat niet",
  NO_FILE: "Er is geen bestand om te downloaden",
  NO_SHIPPING_ID: "Entiteit bestaat niet",
  NOT_COMPLETELY_FILLED: "is niet helemaal gevuld",
  NOT_DELIVERED: "Nog te leveren",
  NOT_PUBLISHED: "Niet gepubliceerd",
  NOTIFICATIONS: "Meldingen",
  NOTIFICATIONS_ADD: "Meldingen toevoegen",
  NOTIFICATIONS_EDIT: "Meldingen bewerken",
  NOTIFICATIONS_DATE: "Datum plaatsing",
  NOTIFICATIONS_END_DATE: "Einddatum",
  NOTIFICATIONS_FILES: "Files",
  NOTIFICATIONS_NO_DATA: "Er zijn op dit moment geen nieuwe meldingen.",
  NOTIFICATIONS_SEARCH: "Zoek op Titel",
  NOTIFICATIONS_VIEW_ALL: "bekijk alle meldingen",
  NUMBER: "Nummer",
  OLD_HARVEST: "De geselecteerde orderregels hebben een oud oogstjaar",
  OPEN: "Open",
  OPEN_PDF: "Open PDF",
  ORDER: "Order",
  ORDERS: "Orders",
  ORDERS_AMOUNT: "Orderbedrag",
  ORDERS_AMOUNT_EX_BTW: "Orderbedrag (excl. BTW)",
  ORDERS_BUYER_REP: "Vert. koper",
  ORDERS_COVER: "Omslag",
  ORDERS_DATE: "Orderdatum",
  ORDERS_DELIVERY_ADDRESS: "Afleveradres",
  ORDERS_DETAILS: "Orderdetails",
  ORDERS_DOWNLOAD: "Download order",
  ORDERS_EX_BTW: "Besteld bedrag excl. BTW",
  ORDERS_FROM_DATE: "Leverdatum vanaf",
  ORDERS_LAST_DATE: "Datum laatste versie",
  ORDERS_LINE_NR: "Orderregelnummer",
  ORDERS_LINES: "Orderregels",
  ORDERS_NUMBER: "Ordernummer",
  ORDERS_NR: "Order nr.",
  ORDERS_PAYMENT: "Voorschot",
  ORDERS_RATE: "Tarief/provisie",
  ORDERS_RECEIPTS: "Ontvangst/retournota",
  ORDERS_RECENT: "Recente orders",
  ORDERS_REF: "Extern ref",
  ORDERS_SCHEME: "Omslagregeling",
  ORDERS_SEARCH:
    "Zoek op ordernummer, wederpartij, oogstjaar en artikel omschrijving",
  ORDERS_SELLER_REP: "Vert. verkoper",
  ORDERS_SKAL: "Skalnummer leverancier",
  ORDERS_STATE: "Order vervallen",
  ORDERS_TYPE: "Documentsoort",
  ORDERS_VERSION_DATE: "Versiedatum",
  ORDERS_VIEW_ALL: "alle orders bekijken",
  OTHER: "Overige",
  OTHER_PARTY_NAME: "Naam wederpartij",
  OTHER_PARTY_NUMBER: "Nummer wederpartij",
  PAID_AMOUNT: "Betaald bedrag",
  PAYMENT_DATE: "Betaaldatum",
  PDF_DOWNLOAD: "Download de PDF.",
  PDF_NOT_SUPPORT: "Uw browser ondersteunt geen PDF's.",
  PLANTING_MATERIAL_SOLD: "Plantgoed afgelopen oogstjaar verkocht",
  PLANTING_MATERIAL_NOTE_ZANT:
    "Oppervlakte uitgangsmateriaal ten behoeve van plantgoed (fijnparteren, 'snipperen', broodmachine, etc)",
  PLUS_SIGN: "+",
  PORTIONS: "Aantal portie(s)",
  PREFERRED_GROWER: "Voorkeurkweker",
  PREFERRED_GROWER_COMPANY: "Bedrijfsnaam voorkeurkweker",
  PREFERRED_GROWER_NAME: "Naam voorkeurkweker",
  PREFERRED_GROWER_NR: "Nr. Voorkeurkweker",
  PREFERRED_GROWER_NR_REL: "Relatienummer voorkeurkweker",
  PREFERENCES: "Voorkeursinstellingen",
  PREFERENCES_CARRIER_REMARKS: "Standaard opmerkingen Drager",
  PREFERENCES_COMMENT: "Standaard opmerking",
  PREFERENCES_CONTAINER: "Gaasbakken standaard op",
  PREFERENCES_FUST_REMARKS: "Standaard opmerkingen Fust",
  PREFERENCES_HARVEST_YEAR: "Standaard Oogstjaar",
  PREFERENCES_INVOICE_NOTE: "Standaard opmerking factuur",
  PREFERENCES_LILY_DELIVERY: "Lelie standaard leveren in",
  PREFERENCES_LILY_ST: "Leliekratten standaard op",
  PREFERENCES_LINE: "In regel #{number}",
  PREFERENCES_LOGO: "CNB Logo afdrukken op leveringsnota",
  PREFERENCES_OTHERS_DELIVERY: "Overige standaard leveren in",
  PREFERENCES_OTHERS_ST: "Fust standaard van",
  PREFERENCES_PACKAGE: "Bij 'eigen fust'",
  PREFERENCES_TO_DELIVER: "Leveren",
  PREFERENCES_TULIP_DELIVERY: "Tulpen standaard leveren in",
  PREVIOUS: "Vorige",
  PRICE: "Prijs",
  PRICE_UNIT: "Prijseenheid",
  PRINT_NOTE: "Wil je de leveringsnota afdrukken?",
  PRODUCT_GROUP: "Hoofdgroep",
  PUBLISHED: "Gepubliceerd",
  PURCHASE_TYPE: "Kooptype",
  QUALITY_PLUS: "Kwaliteit plus",
  QUANTITY: "Aantal",
  QUANTITY_KG: "Aantal Kg/stuks",
  QUANTITY_UNIT: "Aantal eenheid",
  READ_MORE: "Lees meer",
  REASON: "Reden",
  RECEIPT_CONFIRMATION: "Ontvangstbevestiging",
  RECEIPTS_AND_RETURNS: "Ontvangsten en retouren",
  RECEIPTS_AND_RETURNS_HEADER: "Ontvangsten / retouren",
  RECEIPTS_AND_RETURNS_MSG: "Ontvangsten en retouren",
  RECEIPTS_NR: "Ontvangst nummer",
  RECEIPTS_DATE: "Ontvangstdatum",
  RECEIPTS_REPORT: "Ontvangstrapporten K&P",
  RECEIPTS_SEARCH: "Zoek op notanummer, naam wederpartij en ordernummer",
  RECEIPTS_SUPPLIER: "Naam leverancier",
  RECONFIRMATION: "Herbevestiging",
  RELATION: "Relatie",
  RELATION_NR: "Relatie nummer",
  REMAINING: "Overig",
  REMOVE: "Verwijderen",
  REMOVE_COMMENT: "opmerking verwijderen",
  REPORT_APPROVAL: "Ontvangstkeuring",
  REPORTS_AREA_STATEMENT: "Ingediende areaalopgave",
  REPORTS_INVOICED_AREA_STATEMENT_OVERVIEW:
    "Overzicht gefactureerde areaalopgaven",
  REPORT_INSPECTION: "Herkeuring",
  REPORTS: "Rapportages",
  REPORTS_DELIVERED: "Actuele Voorraad K&P",
  REPORTS_EXCEL: "Exporteren naar excel",
  REPORTS_ICP: "ICP-aangifte",
  REPORTS_INFO:
    "Actuele voorraad door CNB ingepakte lelies.\nAlleen te gebruiken tijdens inpakseizoen.",
  REPORTS_INVOICED_DELIVERY: "Gefactureerde leveringen",
  REPORTS_INVOICED_DELIVERY_OVERVIEW: "Overzicht gefactureerde leveringen",
  REPORTS_NR: "Partijnummer",
  REPORTS_PDF: "Openen als .pdf",
  REPORTS_READY: "Partijen gereed voor afroep K&P",
  REPORTS_SEARCH:
    "Zoek op partijnummer, artikelomschrijving en naam leverancier",
  REPORTS_SHOW_ICP: "Toon ICP-aangifte",
  REPORTS_SHOW_VAT: "Toon BTW en omzet rapport",
  REPORTS_TYPE: "Type keuring",
  REPORTS_TULIPS: "G-stadium tulpen K&P",
  REPORTS_VAT: "BTW en omzet",
  RESET: "Reset",
  RESIDENCE: "Woonplaats",
  RESULT: "Resultaat",
  ROLE_GROWER: "Kweker",
  ROLE_PURCHASE: "Aankoop",
  ROLE_SALE: "Verkoop",
  ROYALTIES: "Royalties",
  RR: "RR",
  SAME_BIO:
    "U kunt niet regels van biologische geteelde producten en niet-biologisch geteelde producten op één nota samenvoegen. Maak een nieuwe selectie.",
  SAVE: "Opslaan",
  SAVE_CHANGES: "Wijzigingen opslaan",
  SEARCH: "Zoeken",
  SELECTED: "Met geselecteerd",
  SELECTED_FILTERS: "Gekozen filters:",
  SELLER_NAME: "Naam verkoper",
  SELLER_COMPANY: "Vertegenwoordiger verkoper",
  SERIAL_NR: "Volgnummer",
  SERVICE: "Dienst",
  SERVICE_SUPPORT: "Service & support",
  SERVICE_AND_SUPPORT: "Service en support",
  SETTINGS: "Persoonlijke instellingen",
  SETTINGS_DOCUMENTS:
    "Documenten en adviezen waarvoor u notificaties wil ontvangen:",
  SETTINGS_PASSWORD: "Voor wachtwoord wijzigen, klik op onderstaande knop.",
  SETTINGS_SAVED: "Instellingen opgeslagen",
  SHOW: "Toon",
  SHOW_LESS: "toon minder",
  SHOW_MORE: "toon meer",
  SHOW_UNREAD: "Toon alleen ongelezen",
  SIZE: "Maat",
  SIZE_NR: "Maat {number}",
  STATUS: "Status",
  SUBMIT: "Indienen",
  SUBSCRIPTION: "Abonnement",
  SUCCESS: "Succesvol gedaan!",
  SUPPORT: "Support",
  SUPPORT_ANSWER_ACCESS: `Let op dit kan alleen door de hoofdgebruiker uitgevoerd worden!\nU kunt iemand anders binnen/buiten uw bedrijf, bijv. uw collega of uw boekhouder, toegang geven tot uw (deel)gegevens. U kunt een aanvraag doen via “Gebruikersbeheer” door rechtsboven op uw inlognaam te klikken. Daarna klikt u in het drop down menu op “Gebruikersbeheer”. U ziet dan alle huidige gebruikers. Hier kunt u een nieuwe gebruiker toevoegen en aangegeven wat hij/zij mag zien.\nU klikt op het “+” teken om een gebruiker toe te voegen. U komt dan in een nieuw scherm.\nU geeft naam (dit is ook uw inlognaam) en e-mail adres op en geeft aan in welke taal hij/zij het portaal gaat gebruiken. Omdat uw naam ook uw inlognaam is mogen hier geen spaties in staan. Wij adviseren dan ook hier uw e-mail adres op te geven.\n{imageOne}\nVervolgens geeft u aan welke notificatie hij of zijn mag/moet ontvangen. Dit zijn de e-mail berichten die u ontvangt zodra er een nieuw document beschikbaar is.\nVervolgens klikt u op “opslaan”.\nNadat u heeft opgeslagen is uw account aangemaakt, maar nog niet klaar!\nVervolgens krijgt onderstaand scherm te zien:\n{imageTwo}\nU moet hier uw account nog koppelen aan een klant door nogmaals op de “+” te klikken.\nU krijgt dan onderstaand scherm te zien:\n{imageThree}\nU ziet de gebruikersnaam die u zojuist heeft ingevoerd. Vervolgens klikt u ‘Klant’ aan als u toegang wilt geven tot uw bedrijfsgegevens. Mocht u beheerder zijn voor meerdere bedrijven dan dient u dit proces meerdere keren te doorlopen als deze persoon daar ook toegang toe moet hebben.\nVervolgens geeft u in “Modules” aan tot welke modules deze persoon toegang moet krijgen. Module ‘Algemeen’ dient u altijd aan te vinken!\nVervolgens klikt u op “Opslaan”. De nieuwe gebruiker krijgt nu een mail om de aanvraag te bevestigen.`,
  SUPPORT_ANSWER_ADDRESS:
    "U kunt zelf niets wijzigen. Wijzigingen in uw NAW gegevens kunt u mailen naar administratie@cnb.nl",
  SUPPORT_ANSWER_ALL_DELIVERIES:
    "U kunt dit instellen via de voorkeursinstellingen bij de invoer van leveringen. U vindt een uitgebreide instructie in de handleiding invoeren leveringen. Deze handleiding kunt u vinden onder klantenservice bij Mijn CNB. ",
  SUPPORT_ANSWER_ARRIVED:
    "Er is geen terugkoppeling op het klantportaal over de ontvangst van de leveringsnota door het ketenregister. U kunt voor informatie contact opnemen met de BKD.",
  SUPPORT_ANSWER_BATCH_DATA:
    "Het ketenregister registreert de partijgegevens bij de koper van uw bollen. De koper heeft alleen inzicht in de gegevens die bij de afgeleverde partij horen. Meer informatie kunt u vinden op {link}",
  SUPPORT_ANSWER_CHAIN_REGISTER:
    "Dit is een digitale verbinding tussen het teeltregister van de BKD en Client export in overleg met de NVWA (Nederlandse Voedsel- en WarenAutoriteit). U kunt meer informatie over het ketenregister vinden op {link}",
  SUPPORT_ANSWER_CHANGE_PASSWORD:
    "Uw wachtwoord blijft altijd geldig. Wij adviseren u wel periodiek uw wachtwoord te veranderen.",
  SUPPORT_ANSWER_CNB:
    "Als u uw partijgegevens meldt aan het ketenregister via Mijn CNB dan worden deze ook door CNB verwerkt. U hoeft de levering dan niet meer apart aan CNB te melden.",
  SUPPORT_ANSWER_CORRECTION:
    "U kunt correcties in de partijgegevens aan het ketenregister melden via het digitaal klantenloket van de BKD.",
  SUPPORT_ANSWER_DELIVERIES:
    "Ga naar het menu onderdeel Administratie ‘Leveringen invoeren’. U ziet in het scherm alle nog niet (volledig) geleverde orderregels. Vink de orderregels aan waarvoor u een levering wilt maken en klik op ‘Leveringsnota maken’.\nZie handleiding “leveringen invoeren” voor meer informatie.",
  SUPPORT_ANSWER_DONT:
    "De partijgegevens van de leveringsnota worden niet naar het ketenregister gestuurd, tenzij u dit zelf aangeeft bij de invoer van de leveringsnota.",
  SUPPORT_ANSWER_GROWER:
    "Ga naar het menu onderdeel Administratie ‘Leveringen invoeren’. Klik op ‘Uitgebreid zoeken’ en klik het vinkje aan bij ‘Kooptype’. Daarna klikt u op ‘Kweker’. U ziet nu alle orders waarbij u de voorkeurkweker bent van een kwekersvereniging.",
  SUPPORT_ANSWER_ORDERS: `Klik op 'Uitgebreid zoeken'\n{imageOne}\nU ziet nu een zoekveld waarbij u zelf kunt aangegeven wat u wilt zoeken.\nAls u bijv. alle orders wilt zoeken van een bepaalde wederpartij dan vult u daar de naam in en alle orders die gemaakt zijn tussen u en de wederpartij verschijnen dan in het scherm. U kunt ook nog uitgebreider zoeken door op ‘Toon meer’ te klikken. Dan klapt het scherm verder open voor nog meer zoek mogelijkheden.\n{imageTwo}`,
  SUPPORT_ANSWER_OTHER:
    "U kunt geen partijgegevens van de koopovereenkomst/orders van andere IVB’s aan het ketenregister melden via Mijn CNB. U kunt dit wel rechtstreeks bij de BKD doen via het Digitaal Klanten Loket (DKL) van de BKD.",
  SUPPORT_ANSWER_PASSWORD: `Klik onder het kopje “Overige” op “Persoonlijke instellingen”. Onderaan het scherm klikt u op “Wachtwoord wijzigen” Dan verschijnt onderstaand scherm.\n{imageOne}\nU vult hier uw gebruikersnaam in en klikt op ‘Mailbericht verzenden’. U ontvangt een mail met een link om uw wachtwoord te wijzigen.\nU ziet dan onderstaand scherm\n{imageTwo}\nHier geeft u 2x hetzelfde “nieuwe” wachtwoord in en klikt op ‘Instellen’. Let op dit wachtwoord moet minimaal 8 tekens bevatten, waaronder een hoofdletter, een getal en een leesteken.`,
  SUPPORT_ANSWER_REPORT:
    "U moet voor het afleveren van de bollen de partijgegevens melden aan het ketenregister. Dit kunt u op een eenvoudige manier doen bij het maken van de leveringsnota.",
  SUPPORT_ANSWER_SEARCH: `U kunt onder ‘Facturen’ klikken op Uitgebreid zoeken. Dan ziet u een zoekveld (als u op ‘Toon meer’ klikt zie u nog meer zoekvelden) waarbij u op bijv. één ordernummer alle facturen kunt terugvinden.\nTik het ordernummer in en klik dan op Zoeken\n{image}\nVervolgens kunt u alle facturen bekijken door op het pdf pictogram te klikken dat voor het factuurnummer staat.`,
  SUPPORT_ANSWER_SEEN: `U kunt alle ongelezen documenten apart inzien onder bijv. orders, facturen en rekeningoverzichten.\nU klikt aan waarvan u de ongelezen documenten wilt inzien. Bijv. Orders.\nU klikt op Orders. Alle ongelezen/nieuwe documenten zijn vetgedrukt. U kunt deze filteren (u ziet dan alleen de ongelezen/nieuwe documenten) door het schuifje ‘Toon alleen ongelezen’ aan te zetten\n{imageOne}\nDocumenten bijv. Orders die al gezien zijn kunt u uiteraard ook weer markeren als ongelezen. Dit kunt u doen door te gaan naar het scherm Orders. U ziet hier nu de ongelezen en gelezen Orders. Als u een order wilt markeren als ongelezen (de Order wordt dan weer vetgedrukt) dan klikt u de betreffende order aan door een vinkje te zetten in de kolom ervoor.\n{imageTwo}\nDaarna klikt u in het scherm ‘Maak een keuze’ u kunt hier kiezen tussen: {list}`,
  SUPPORT_ANSWER_TERMINATE_ACCESS:
    "U kunt de wijziging doen via “Gebruikersbeheer” door rechtsboven op uw inlognaam te klikken. Daarna klikt u in het drop down menu op “Gebruikersbeheer”. U ziet hier dan alle huidige gebruikers. U kunt hier de gebruiker verwijderen of de toegang wijzigen.",
  SUPPORT_QUESTION_ACCESS:
    "Ik wil iemand anders van het bedrijf toegang geven tot mijn gegevens. Kan dat?",
  SUPPORT_QUESTION_ADDRESS: "Kan ik zelf iets wijzigen in Mijn CNB?",
  SUPPORT_QUESTION_ALL_DELIVERIES:
    "Ik wil dat de partijgegevens van alle leveringsnota’s die ik maak standaard naar het ketenregister worden gestuurd?",
  SUPPORT_QUESTION_ARRIVED:
    "Hoe weet ik zeker dat mijn gegevens zijn aangekomen bij het ketenregister?",
  SUPPORT_QUESTION_BATCH_DATA:
    "Wat doet het ketenregister met mijn partijgegevens?",
  SUPPORT_QUESTION_CHAIN_REGISTER: "Wat is het ketenregister?",
  SUPPORT_QUESTION_CHANGE_PASSWORD:
    "Hoe vaak moet ik mijn wachtwoord wijzigingen?",
  SUPPORT_QUESTION_CNB:
    "Als ik mijn partijgegevens meld aan het ketenregister via Mijn CNB  moet ik dan mijn leveringen apart aan CNB melden?",
  SUPPORT_QUESTION_CORRECTION:
    "Kan ik correcties in de partijgegevens melden aan het ketenregister?",
  SUPPORT_QUESTION_DELIVERIES: "Waar kan ik een levering invoeren?",
  SUPPORT_QUESTION_DONT:
    "Ik wil niet dat de partijgegevens van de leveringsnota aan het ketenregister worden gemeld?",
  SUPPORT_QUESTION_GROWER:
    "Hoe voer ik een levering van een kwekersvereniging in?",
  SUPPORT_QUESTION_ORDERS: "Waar vind ik de koopovereenkomsten of orders?",
  SUPPORT_QUESTION_OTHER:
    "Kan ik via Mijn CNB ook partijgegevens van koopovereenkomsten/orders van andere IVB’s aan het ketenregister melden?",
  SUPPORT_QUESTION_PASSWORD: "Hoe moet ik mijn wachtwoord wijzigen?",
  SUPPORT_QUESTION_REPORT:
    "Wanneer moet ik mijn partijgegevens melden aan het ketenregister?",
  SUPPORT_QUESTION_SEEN: "Wat gebeurt er als ik een document op ‘gezien’ zet?",
  SUPPORT_QUESTION_TERMINATE_ACCESS:
    "Iemand heeft toegang tot mijn gegevens en ik wil dat stop zetten?",
  SUPPORT_TITLE_ADDRESS: "NAW (Naam-Adres-Woonplaats)",
  SUPPORT_TITLE_DELIVERIES: "Leveringen",
  SUPPORT_TITLE_DOCUMENT: "Nieuwe Documenten",
  SUPPORT_TITLE_LOGIN: "Inloggen:",
  SUPPORT_TITLE_ORDERS: "Orders",
  SUPPORT_TITLE_SEARCH:
    "Hoe kan ik van een koopovereenkomst of order alle facturen inzien, printen en opslaan?",
  SURFACE: "Oppervlakte",
  SURE: "Weet je het zeker?",
  TEXT: "Tekst",
  TEXT_EN: "Tekst EN",
  TEXT_NL: "Tekst NL",
  TEXT_TEASER: "Tekst teaser",
  TEXT_TEASER_EN: "Tekst teaser EN",
  TEXT_TEASER_NL: "Tekst teaser NL",
  TIME: "Tijd",
  TITLE: "Titel",
  TITLE_EN: "Titel EN",
  TITLE_NL: "Titel NL",
  TO: "tot",
  TOTAL: "Totaal",
  TOTAL_DEDUCTIONS: "Totaal inhoudingen/blokkeringen",
  TOTAL_GREATER_ZERO: "#Totaal moet groter zijn dan 0",
  TOTAL_INVOICE_AMOUNT: "Totaal factuurbedragen",
  TRANSPORT: "Vervoer",
  TULIP: "Tulp",
  TYPE: "Type",
  TYPE_BULB: "Bijz. bolgewassen",
  TYPE_GENERAL: "Algemeen",
  TYPE_LILIES: "Lelies",
  TYPE_TULIP: "Tulpen",
  UNIT: "Eenheid",
  UPLOAD_EXTENSION_ERROR:
    "Alleen de volgende bestandsextensies zijn beschikbaar:",
  UPLOAD_SIZE_ERROR: "Het geüploade bestand moet kleiner zijn dan 10 MB",
  CUSTOMER_COMPLAINTS: "Zuurnota invoeren",
  UNDER_CONTRACT_BULB:
    "Indien uw bollen op contract worden geteeld s.v.p. vermelding naam en mobiel telefoonnummer van contractnemer :",
  USER_MANUALS: "Handleidingen",
  USER_MANUALS_DELIVERIES_TITLE:
    "Mijn CNB gebruikershandleiding Invoeren leveringen",
  USER_MANUALS_DELIVERIES_DESCRIPTION: "Handleiding invoeren leveringen",
  USER_MANUALS_STATEMENTS_TITLE:
    "Mijn CNB gebruikershandleiding Rekeningoverzicht en BTW en omzetoverzicht per betaaldatum",
  USER_MANUALS_STATEMENTS_DESCRIPTION:
    "Handleiding Rekening en betaaldatumovericht",
  USER_MANUALS_EXCEL_TITLE:
    "Mijn CNB gebruikershandleiding Rekeningoverzicht naar Excel exporteren",
  USER_MANUALS_EXCEL_DESCRIPTION: "Handleiding Rekening naar Excel exporteren",
  USER_MANUALS_RESET_PASSWORD_TITLE:
    "Mijn CNB gebruikershandleiding Wachtwoord resetten",
  USER_MANUALS_RESET_PASSWORD_DESCRIPTION: "Handleiding wachtwoord resetten",
  USER_MANUALS_ZURRNOTA_TITLE:
    "Mijn CNB gebruikershandleiding Zuurnota invoeren",
  USER_MANUALS_ZURRNOTA_DESCRIPTION: "Handleiding Zuurnota invoeren",
  USER_MANUALS_AREAAL_TITLE:
    "Mijn CNB gebruikershandleiding Areaalopgaven invoeren",
  USER_MANUALS_AREAAL_DESCRIPTION: "Handleiding Areaalopgaven invoeren",
  USER_MANUALS_BEDRIJFSGEGEVENS_TITLE:
    "Mijn CNB gebruikershandleiding Bedrijfsgegevens invoeren",
  USER_MANUALS_BEDRIJFSGEGEVENS_DESCRIPTION:
    "Handleiding Bedrijfsgegevens invoeren",
  USER_MANUALS_GEBRUIKERSBEHEER_TITLE:
    "Mijn CNB gebruikershandleiding gebruikersbeheer",
  USER_MANUALS_GEBRUIKERSBEHEER_DESCRIPTION: "Handleiding gebruikersbeheer",

  USERS: "Gebruikersbeheer",
  VAT_RATE: "BTW tarief",
  VAT_STATUS: "BTW Status",
  VALIDATION_EMAIL: "E-mail is niet geldig",
  VALIDATION_MORE_THAN_START: "Dit veld mag niet meer dan",
  VALIDATION_MORE_THAN_END: "tekens bevatten",
  VALIDATION_MORE_THAN_ONE: "Moet meer dan 1 zijn",
  VALIDATION_MORE_THAN_ZERO: "Moet meer dan 0 zijn",
  VALIDATION_MUST_CONTAIN_START: "Dit veld moet",
  VALIDATION_MUST_CONTAIN_END: "tekens bevatten",
  VALIDATION_ONLY_POSITIVE: "Alleen positieve getallen toegestaan",
  VALIDATION_ONLY_NUMBERS: "Alleen getallen toegestaan",
  VALIDATION_REQUIRED: "Verplicht",
  VERSION: "Versie",
  VERSION_NR: "Versienr.",
  VERSIONS: "Versies",
  VIEW_PDF: "Bekijk PDF document",
  VISIBLE: "Zichtbaar",
  WEBSITE: "CNB Website",
  WELCOME: "Welkom",
  X_COORDINATE: "X-coördinaat",
  YES: "Ja",
  Y_COORDINATE: "Y-coördinaat",
  ADDRESS: "Adres",
  PLACE: "Plaats",
  SELLER_EMAIL: "E-mail verkoper",
  AGREEMENT_NUMBER: "Overeenkomstnummer",
  AGREEMENT_NUMBER_SUBJECT: "Onderwerp: CNB overeenkomstnummer",
  QUANTITY_RECEIVED: "Ontvangen hoeveelheid",
  NUMBER_OF_BULBS: "Aantal zure bollen",
  SPECIES_CULTIVAR: "Soort (cultivar)",
  MATE: "Maat",
  RELATIONSHIP_NO: "Relatie nummer",
  CUSTOMER_COMPLAINT_NOTIFICATION:
    "Vergeet u de verkoper niet op de hoogte te stellen? Het formulier wordt niet naar hen verzonden.",
  BULBS_ARE_AVAILABLE: "De bollen staan ter beschikking",
  NO_OF_SPHERES: "Het aantal zure bollen is bepaald door monstertrekking",
  ORBS_ARE_DESTROYED:
    "De bollen zijn/worden vernietigd (Let op: Termijn bewaarplicht koper volgens Artikel 8.9 lid 1 HR)",
  OTHER_VIZ: "Anders, nl.",
  COMPLETE_BUYER_INFORMATION: "Volledige kopersinformatie hieronder:",
  CHECK_AND_COMPLETE_BELOW_AS:
    "Gelieve hieronder aan te kruisen/in te vullen wat van toepassing is:",
  MAKE_COMPLAINT: "Zuurnota Invoeren",
  THE_UNDESIGNED_DECLARES_THE_NUMBER_OF_SOUR_BULBS:
    "Hierbij verklaar ik het aantal zure bollen gevonden in de volgende partij(en)",
  COMPLAINT_AGREEMENT_LABEL:
    "Hierbij verklaar ik dat ik dit formulier naar waarheid heb ingevuld",
  INVALID_PRICE_FORMAT: "Ongeldige prijsnotatie",
  INVALID_PRICE_MESSAGE: 'Geaccepteerd formaat: "123,45" of "123"',
  SURFACE_TITLE: "Oppervlakte T1",
};
